import React from "react";
import { IconSpinner } from "@ui/icons";

const LoadingSpinnerScreen = (props) => {
    return (
        <div className="flex flex-col h-full">
            <div className="grid h-screen place-items-center">
                <div className="text-center">
                    <div className="w-16 mx-auto">
                        <IconSpinner className="text-skin-primary h-14 w-14 md:h-16 md:w-16" />
                    </div>
                    {props.text && (
                        <p className="font-semibold text-2xl text-skin-dark mt-6">
                            {props.text}
                        </p>
                    )}
                    {props.subText && (
                        <p className="text-skin-dark mt-2 px-12">
                            {props.subText}
                        </p>
                    )}
                </div>
            </div>
            <div className="items-center flex flex-col p-16">
                {props.footerImageUrl && <img src={props.footerImageUrl} />}
            </div>
        </div>
    );
};

export default LoadingSpinnerScreen;
